export default __webpack_public_path__ + "ea35d4ddbfab423209afee4f6c6380d1.png";